import { type MetaFunction } from '@remix-run/node'
import programVeterans from './program-veterans.png'

export const meta: MetaFunction = () => [
	{ title: 'Insurance for Veterans' },
	{
		name: 'description',
		content: 'We offer insurance for veterans.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Veterans</h1>
			<img
				src={programVeterans}
				alt="A uniform showing multiple military service ribbons"
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Veterans
			</p>
		</main>
	)
}
